<script>
import message from '../services/message'

// 将现有操作结果交给统一消息中心；消费状态后同一结果再次发生仍能提示。
export default {
  name: 'OperationMessage',
  props: { value: { default: '' }, type: { type: String, default: 'info' } },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        if (!value) return
        this.$nextTick(() => {
          if (this.value !== value) return
          message.show(value, this.type)
          this.$emit('consumed', value)
        })
      }
    }
  },
  render (h) { return h() }
}
</script>
